<style lang="scss" scoped>
  .separator {
    margin: 6em;
  }

  .indent {
    padding-left: 1em;
  }

  .top-action {
    align-items: center;
    display: flex;
    flex-direction: row;
    height: 100%;
    justify-content: center;
    width: 100%;

    a {
      background-color: #004d40;
      border-radius: .25em;
      color: #fff;
      font-size: 10pt;
      font-weight: 900;
      padding: .25em 1em;

      &:hover {
        background-color: #00251a;
        text-decoration: none;
      }
    }
  }

  .breadcumb {
    margin: 0 0 1em;
  }

  .meta {
    font-size: 11pt;

    div {
      display: inline-block;

      &:not(:first-child) {
        margin-left: 2em;
      }
    }
  }

  .description {
    margin: 2em 0;
  }

  .problems {
    margin: 0 0 1em;

    .problem {
      margin: 0 0 1em;
    }

    .title {
      align-items: flex-start;
      flex-direction: column;
    }

    .scores {

      span {
        color: #00c853;
      }
    }

    .action {
      a {
        background-color: #d34836;
        border-radius: .25em;
        color: #fff;
        font-size: 12pt;
        font-weight: 900;
        padding: .25em 1em;

        &:hover {
          background-color: #a01503;
          text-decoration: none;
        }
      }
    }

    .v-middle {
      align-items: center;
      display: flex;
      flex-direction: row;
      height: 100%;
      justify-content: center;
      width: 100%;
    }
  }
</style>

<template>
  <div>
    <NavBar />

    <div class="container">
      <div v-if="assignment">
        <div class="breadcumb">
          <router-link to="/assignments">Assignments</router-link>
          /
          {{ assignment.title }}
        </div>

        <div class="row">
          <div class="col-10">
            <h3>{{ assignment.title }}</h3>
            <div class="meta">
              <div>
                Starts <strong>{{ renderNiceDate(assignment.start_date) }}</strong>
              </div>
              <div>
                Duration
                <strong>{{ getDuration(assignment.start_date, assignment.end_date) }}</strong>
              </div>
            </div>
          </div>
          <div class="col-2">
            <div class="top-action">
              <router-link :to="`/assignments/${assignment.id}/scoreboard`">
                View Scoreboard
              </router-link>
            </div>
          </div>
        </div>

        <div class="description">
          {{ assignment.description }}
        </div>

        <h5>Problem List</h5>
        <div v-if="problems.length > 0" class="indent">
          <div class="problems">
            <div v-for="problem in problems" :key="problem.id" class="problem row">
              <div class="col-5">
                <div class="title">
                  <h5>{{ problem.title }}</h5>
                </div>
              </div>
              <div class="col-2">
                <div class="v-middle">
                  <strong class="scores">
                    {{ problem.submissionScores }}/<span>{{ problem.scores }}pts</span>
                  </strong>
                </div>
              </div>
              <div class="col-3">
                <div class="v-middle">
                  <span>
                    time limit
                    <strong>{{ problem.time_limit }}s</strong>
                  </span>
                </div>
              </div>
              <div class="col-2">
                <div class="v-middle action">
                  <router-link :to="`/problems/${problem.id}`">
                    View
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="indent">
          No problem.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDuration, renderNiceDate } from '@/helpers/dateFormatter';
import { fetchApi } from '@/helpers/fetchApi';
import { redirectIfNotLoggedIn } from '@/helpers/loginChecker';

import NavBar from '@/components/NavBar.vue';

async function processAssignmentData(vm) {
  const fetch = fetchApi(vm);
  const assignmentId = vm.$route.params.assignment_id;
  const assignment = await fetch(`/assignments/${assignmentId}`, { withToken: true });

  vm.updateAssignment(assignment.data);
}

async function processProblemList(vm) {
  const fetch = fetchApi(vm);
  const assignmentId = vm.$route.params.assignment_id;
  const problems = await fetch(`/problems?assignment_id=${assignmentId}`, { withToken: true });

  vm.updateProblemList(problems.data.reverse());
}

export default {
  name: 'problem_list',
  components: {
    NavBar,
  },
  data: () => ({
    assignment: {},
    problems: [],
  }),
  methods: {
    getDuration,
    renderNiceDate,

    async fetchScores(problemId) {
      const fetch = fetchApi(this);
      const req = await fetch(`/problems/${problemId}/scores`, { withToken: true });

      if (!req) {
        return '?';
      }

      return req.data.scores || '?';
    },
    async updateAssignment(assignment) {
      this.assignment = assignment;

      await this.$nextTick();
    },
    async updateProblemList(problems) {
      this.problems = problems.map((elm) => {
        const problem = elm;
        problem.submissionScores = '?';

        return problem;
      });

      this.problems.forEach(async (problem, idx) => {
        this.problems[idx].submissionScores = await this.fetchScores(problem.id);
      });

      await this.$nextTick();
    },
  },
  watch: {
    $route: {
      immediate: true,
      async handler() {
        if (await redirectIfNotLoggedIn(this)) {
          return;
        }

        await processAssignmentData(this);
        await processProblemList(this);
      },
    },
  },
};
</script>
